<div class="content verification-page">

  <!-- Begin dashboard -->
  <div class="container-fluid" style="max-height: max-content">

    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-3 verification-page-header">
  <div>
    <h1 class="dashboard-title">Patient Information Needed</h1>
    <p class="verification-page-subtitle">Review patient details, verify section inputs, and submit updates.</p>
  </div>

  <div class="verification-timer">
    ⏱ {{ timerDisplay }}
  </div>
  </div>

    <!-- Content Row -->
    <div class="row">
      <!-- Patient Form Card -->

      <div class="patient-card-container verification-top-card-wrap">
        <div class="patient-card verification-top-card">
          <div class="card-body">
            <div class="card-content">
              <!-- Patient Form -->
              <form [formGroup]="patientForm" (ngSubmit)="onSubmitPatientAndEnableVerification()">
                <fieldset [disabled]="viewMode === 'patient'">
                  <!-- Main information grid -->
                  <div class="form-grid primary-grid">
                    <!-- First Name -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Patient First Name:</mat-label>
                        <input matInput formControlName="patientName">
                      </mat-form-field>
                    </div>

                    <!-- Last Name -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Patient Last Name:</mat-label>
                        <input matInput formControlName="patientLastName">
                      </mat-form-field>
                    </div>

                    <!-- Patient DOB -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Patient DOB:</mat-label>
                        <input matInput [matDatepicker]="patientPicker" formControlName="patientDob" placeholder="MM/DD/YYYY">
                        <mat-datepicker-toggle matSuffix [for]="patientPicker"></mat-datepicker-toggle>
                        <mat-datepicker #patientPicker></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <div class="form-field">
                      <mat-form-field
                        appearance="outline"
                        class="w-100 payer-field">

                        <mat-label>Carrier Name</mat-label>

                        <input
                          matInput
                          type="text"
                          placeholder="Search carrier name or payer ID"
                          [matAutocomplete]="payerAuto"
                          [formControl]="payerSearchControl"
                          (focus)="onPayerSearchFocus()">

                        <button
                          *ngIf="payerSearchControl.value && payerSearchControl.enabled"
                          mat-icon-button
                          matSuffix
                          type="button"
                          class="payer-clear-btn"
                          aria-label="Clear carrier"
                          (click)="clearPayerSelection(); $event.stopPropagation()">

                          <mat-icon>close</mat-icon>
                        </button>

                        <mat-autocomplete
                          #payerAuto="matAutocomplete"
                          [displayWith]="displayPayer"
                          (optionSelected)="onPayerSelected($event.option.value)"
                          class="payer-autocomplete-panel"
                          panelWidth="380px">

                          <mat-option
                            *ngIf="payerSearchLoading"
                            disabled
                            class="payer-loading-option">

                            <span class="spinner-border spinner-border-sm mr-2"></span>
                            Loading carriers...

                          </mat-option>

                          <mat-option
                            *ngFor="let payer of filteredPayers; trackBy: trackByFn"
                            [value]="payer"
                            class="payer-mat-option">

                            <div class="payer-option">

                              <div class="payer-option-main">
                                {{ payer.name }}
                              </div>

                              <div
                                *ngIf="payer.payerIdCode"
                                class="payer-option-code">

                                Payer ID: {{ payer.payerIdCode }}

                              </div>

                            </div>

                          </mat-option>

                          <mat-option
                            *ngIf="
                              !payerSearchLoading &&
                              payerSearchControl.value &&
                              filteredPayers.length === 0
                            "
                            disabled>

                            No matching carrier found

                          </mat-option>

                        </mat-autocomplete>

                        <mat-hint
                          *ngIf="selectedPayer?.payerIdCode"
                          class="payer-selected-hint">

                          Payer ID: {{ selectedPayer.payerIdCode }}

                        </mat-hint>

                        <mat-error
                          *ngIf="
                            patientForm.get('insuranceProvider')?.touched &&
                            patientForm.get('insuranceProvider')?.hasError('required')
                          ">

                          This field is required!

                        </mat-error>

                      </mat-form-field>
                    </div>

                    <!-- Career Name -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Name of Insurance Provider: </mat-label>
                        <input matInput formControlName="insuranceProviderName">
                      </mat-form-field>
                    </div>

                    <!-- Member ID -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Member ID:</mat-label>
                        <input matInput formControlName="memberId">
                        <mat-error *ngIf="patientForm.controls.memberId.errors?.required">This field is required!</mat-error>
                      </mat-form-field>
                    </div>

                    <!-- Office -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100" >
                        <mat-label>Office</mat-label>
                        <mat-select formControlName="officeId" class="text-primary" [disabled]="viewMode === 'patient'" (selectionChange)="onOfficeTypeChange($event.value)">
                          <mat-option class="text-primary" *ngFor="let type of OfficeType" [value]="type.id" [disabled]="viewMode === 'patient'">{{type.name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="patientForm.controls.officeId.errors?.required">This field is required!</mat-error>
                      </mat-form-field>
                    </div>

                    <!-- Member DOB -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Member DOB:</mat-label>
                        <input matInput [matDatepicker]="memberPicker" formControlName="memberDob" placeholder="MM/DD/YYYY">
                        <mat-datepicker-toggle matSuffix [for]="memberPicker"></mat-datepicker-toggle>
                        <mat-datepicker #memberPicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Secondary information grid -->
                  <div class="form-grid secondary-grid">
                    <!-- Member DOB -->
                    <!--<div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Member DOB:</mat-label>
                        <input matInput [matDatepicker]="memberPicker" formControlName="memberDob" placeholder="MM/DD/YYYY">
                        <mat-datepicker-toggle matSuffix [for]="memberPicker"></mat-datepicker-toggle>
                        <mat-datepicker #memberPicker></mat-datepicker>
                      </mat-form-field>
                    </div>-->
                    <!-- Plan Creation -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Plan Creation:</mat-label>
                        <mat-select formControlName="planCreation" class="text-primary" [disabled]="viewMode === 'patient'" (selectionChange)="onFormTypeChange($event.value)">
                          <mat-option class="text-primary" *ngFor="let items of creationType" [value]="items.value" [disabled]="viewMode === 'patient'">{{items.viewValue}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- Network Type -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Network Type:</mat-label>
                        <mat-select formControlName="networkType" class="text-primary" [disabled]="viewMode === 'patient'">
                          <mat-option class="text-primary" *ngFor="let items of nType" [value]="items.value" [disabled]="viewMode === 'patient'">{{items.viewValue}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- Group ID -->
                    <!-- <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100 group-id-field">
                        <mat-label>Group ID:</mat-label>
                        <input matInput formControlName="groupId" matTooltip="Standard Search" matTooltipPosition="above">
                        <span matSuffix class="group-id-suffix">
                          <button mat-icon-button color="primary" class="trigger-btn" type="button" (click)="onRegister()" [disabled]="viewMode === 'patient'">
                            <mat-icon>search</mat-icon>
                          </button>
                          <button mat-icon-button class="trigger-btn" type="button" (click)="openGroupIdModal()" data-toggle="modal" data-target="#groupIdModal" [disabled]="viewMode === 'patient'">
                            <mat-icon>list</mat-icon>
                          </button>
                        </span>
                        <mat-error *ngIf="patientForm.controls.groupId.errors?.required">This field is required!</mat-error>
                      </mat-form-field>
                    </div> -->
                    <!-- Group ID -->
                    <div class="form-field group-id-wrapper">

                      <mat-form-field appearance="outline" class="w-100 group-id-field">
                        <mat-label>Group ID:</mat-label>

                        <input
                          matInput
                          formControlName="groupId"
                          matTooltip="Standard Search"
                          matTooltipPosition="above"
                          (focus)="showGroupSearchPanel()"
                          (click)="showGroupSearchPanel()"
                          (input)="onGroupIdInput()"
                        >

                        <span matSuffix class="group-id-suffix">

                          <span
                            class="group-scope-indicator"
                            [class.global]="selectedGroupScope === 'GLOBAL'"
                            [matTooltip]="selectedGroupScope === 'GLOBAL' ? 'Global plan' : 'Current Client plan'"
                            [attr.aria-label]="selectedGroupScope === 'GLOBAL' ? 'Global plan' : 'Current Client plan'"
                            role="img"
                          >
                            {{ selectedGroupScope === 'GLOBAL' ? 'G' : 'C' }}
                          </span>

                          <!-- Standard search -->
                          <button
                            mat-icon-button
                            color="primary"
                            class="trigger-btn"
                            type="button"
                            (click)="onRegister()"
                            [disabled]="viewMode === 'patient'"
                          >
                            <mat-icon>search</mat-icon>
                          </button>

                        </span>

                        <mat-error *ngIf="patientForm.controls.groupId.errors?.required">
                          This field is required!
                        </mat-error>
                      </mat-form-field>


                      <!-- Inline Group / Plan Search -->
                      <div
                        class="group-inline-search"
                        *ngIf="showGroupSearch && viewMode !== 'patient'"
                      >

                        <!-- Header -->
                        <div class="group-search-title-row">
                          <div class="group-search-title-wrap">
                            <mat-icon class="group-search-title-icon">manage_search</mat-icon>

                            <div>
                              <div class="group-search-title">Plan Search</div>
                              <div class="group-search-subtitle">
                                Search and select a group plan
                              </div>
                            </div>
                          </div>

                          <button
                            type="button"
                            mat-icon-button
                            class="group-search-close"
                            matTooltip="Close"
                            (click)="closeGroupSearch()"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>


                        <div class="plan-search-domain-switch" role="group" aria-label="Plan search domain">
                          <span class="domain-switch-label">Search domain</span>
                          <button type="button" [class.active]="planSearchDomain === 'DENTAL'"
                                  [attr.aria-pressed]="planSearchDomain === 'DENTAL'"
                                  (click)="changePlanSearchDomain('DENTAL')">Dental</button>
                          <button type="button" [class.active]="planSearchDomain === 'MEDICAL'"
                                  [attr.aria-pressed]="planSearchDomain === 'MEDICAL'"
                                  (click)="changePlanSearchDomain('MEDICAL')">Medical</button>
                        </div>

                        <div class="group-search-scope" role="group" aria-label="Plan search scope">
                          <button type="button" class="group-scope-option"
                            [class.active]="groupSearchScope === 'CLIENT'"
                            [attr.aria-pressed]="groupSearchScope === 'CLIENT'"
                            (click)="setGroupSearchScope('CLIENT')">
                            Current Client
                          </button>
                          <button type="button" class="group-scope-option"
                            [class.active]="groupSearchScope === 'GLOBAL'"
                            [attr.aria-pressed]="groupSearchScope === 'GLOBAL'"
                            (click)="setGroupSearchScope('GLOBAL')">
                            Global Plan Search
                          </button>
                        </div>

                        <!-- Search -->
                        <div class="group-search-header">

                          <div class="group-search-input-wrap">

                            <input
                              type="text"
                              class="form-control group-search-input"
                              placeholder="Search group number..."
                              [(ngModel)]="groupSearchText"
                              [ngModelOptions]="{ standalone: true }"
                              (keydown.enter)="$event.preventDefault(); searchGroup()"
                            >

                            <button
                              type="button"
                              class="group-search-button"
                              matTooltip="Search plan"
                              (click)="searchGroup()"
                            >
                              <mat-icon>search</mat-icon>
                            </button>

                          </div>

                        </div>

                          <!-- Results Header -->
                          <div
                            class="group-search-result-header"
                            *ngIf="groupResults?.length > 0"
                          >
                            <div>Group ID</div>
                            <div>Plan Name</div>
                            <div>Updated By</div>
                            <div>Date</div>
                          </div>
                        <!-- Results -->
                        <ng-container *ngIf="groupResults?.length > 0; else noGroupResults">

                          <div class="group-search-results">

                          <button
                            type="button"
                            class="group-search-result"
                            *ngFor="let item of groupResults"
                            (click)="selectGroupId(item.groupNumber, item.planName)"
                          >

                            <!-- Group ID -->
                            <div
                              class="group-result-number"
                              [matTooltip]="item.groupNumber"
                              matTooltipPosition="above"
                            >
                              {{ item.groupNumber }}
                            </div>

                            <!-- Plan Name -->
                            <div
                              class="group-result-plan"
                              [matTooltip]="item.planName || 'NO-PLAN'"
                              matTooltipPosition="above"
                            >
                              {{ item.planName || 'NO-PLAN' }}
                            </div>

                            <!-- Updated By -->
                            <div
                              class="group-result-updated-by"
                              [matTooltip]="item.updatedBy || '-'"
                              matTooltipPosition="above"
                            >
                              {{ item.updatedBy || '-' }}
                            </div>

                            <!-- Updated Date -->
                            <div class="group-result-date">
                              {{ item.updatedAt || '-' }}
                            </div>

                          </button>

                          </div>

                        </ng-container>


                        <ng-template #noGroupResults>
                          <div
                            *ngIf="searchedOnce || groupSearchLoading"
                            class="group-search-empty"
                          >
                            {{ groupSearchLoading ? 'Searching plans...' : (groupSearchErrorMsg || 'No results found') }}
                          </div>
                        </ng-template>

                      </div>

                    </div>
                    <!-- Plan Name -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Plan name:</mat-label>
                        <input matInput formControlName="planName">
                      </mat-form-field>
                    </div>

                    <!-- Employer Name -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Name of the Employer:</mat-label>
                        <input matInput formControlName="employerName">
                        <mat-error *ngIf="patientForm.controls.employerName.errors?.required">This field is required!</mat-error>
                      </mat-form-field>
                    </div>

                    <!-- Plan Type -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Plan Type:</mat-label>
                        <mat-select formControlName="planType" class="text-primary" (selectionChange)="onPlanTypeChange($event.value)" [disabled]="viewMode === 'patient'">
                          <mat-option class="text-primary" *ngFor="let type of filteredPlanTypes" [value]="type.value" [disabled]="viewMode === 'patient'">{{type.viewValue}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- Form Type -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Form Type:</mat-label>
                        <mat-select formControlName="formType" class="text-primary" (selectionChange)="onPlanTypeChange($event.value)" [disabled]="viewMode === 'patient'">
                          <mat-option class="text-primary" *ngFor="let items of fType" [value]="items.value" [disabled]="viewMode === 'patient'">{{items.viewValue}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- Insurance Phone Number -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Telephone Number of Insurance:</mat-label>
                        <input matInput formControlName="insurancePhoneNumber" type="tel" pmPhoneFormat>
                        <mat-error *ngIf="patientForm.controls.insurancePhoneNumber.errors?.required">This field is required!</mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Additional information (textarea fields) -->
                  <div class="form-grid notes-grid">
                    <!-- Remarks -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Remarks:</mat-label>
                        <textarea matInput [disabled]="viewMode === 'patient'"
                                  formControlName="remarks"
                                  rows="3"
                                  cdkTextareaAutosize
                                  cdkAutosizeMinRows="3"
                                  cdkAutosizeMaxRows="5">
                </textarea>
                      </mat-form-field>
                    </div>

                    <!-- Notes -->
                    <div class="form-field">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Notes:</mat-label>
                        <textarea matInput [disabled]="viewMode === 'patient'"
                                  formControlName="notes"
                                  rows="3"
                                  cdkTextareaAutosize
                                  cdkAutosizeMinRows="3"
                                  cdkAutosizeMaxRows="5">
                </textarea>
                      </mat-form-field>
                    </div>
                  </div>

                </fieldset>

                <!-- Action buttons -->
                <div class="action-buttons d-flex justify-content-between align-items-center">

                  <!-- Left side -->
                  <div>
                    <button type="button" (click)="goBack()" class="btn btn-secondary">
                      Back
                    </button>
                  </div>

                  <!-- Right side -->
                  <div>
                    <button
                      type="button"
                      class="btn btn-info mr-2"
                      [disabled]="viewMode === 'patient' || !patientForm.get('officeId')?.value"
                      (click)="openProviderModal()"
                    >
                      Provider Details
                    </button>

                    <button *ngIf="!clientId"
                            class="btn btn-primary"
                            type="submit"
                            [disabled]="!patientForm.valid || viewMode === 'patient'"
                            >
                      Update Patient Info
                    </button>

                    <button *ngIf="clientId"
                            class="btn btn-primary"
                            type="submit"
                            [disabled]="!patientForm.valid || viewMode === 'patient'"
                            >
                      Update
                    </button>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Insurance Form Card with Scrollable Content -->
      <!--<div class="col-xl-12 col-md-12 mb-2" *ngIf="!notEligilbleSelected">
        <div class="card border-left-primary shadow h-100 py-2" style="max-height: max-content;">
          <div class="card-body pt-1">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-primary mb-1">
                  <mat-tab-group >
                    &lt;!&ndash;Appointment Info&ndash;&gt;
                    <mat-tab *ngIf="!shortFormSelected" label="Appointment Info">

                      <form [formGroup]="insuranceVerifyForm" (ngSubmit)="onSubmitInsurance()" class="full-width-form">
                        <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable ">
                          <table mat-table [dataSource]="proceduresData" class="full-width-table">
                            &lt;!&ndash; Procedure Name Column &ndash;&gt;
                            <ng-container matColumnDef="procedureName">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column procedure-header" (mousedown)="startResize($event, 'procedureName')"> Procedure Name </th>
                              <td mat-cell *matCellDef="let procedureName; let i = index" class="procedure-name">
                                {{ procedureName.name }}
                              </td>
                            </ng-container>

                            &lt;!&ndash; Procedure Input Column &ndash;&gt;
                            <ng-container matColumnDef="procedureInput">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'procedureInput')"> Procedure Input </th>
                              <td mat-cell *matCellDef="let procedureInput; let i = index" [ngClass]="{ 'highlight-empty': isPatientFormInitialized && !proceduresInput.at(i).get('procedureInput')?.value }">
                                <mat-form-field  class="full-width-input spaced-field small-placeholder" >
                                  <input matInput [formControl]="proceduresInput.at(i).get('procedureInput')">
                                  <mat-placeholder class="text-center">Enter Procedures</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Table Headers and Rows &ndash;&gt;
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                          </table>
                        </fieldset>
                        &lt;!&ndash; Buttons for submit and cancel &ndash;&gt;
                        <div class="form-buttons mt-2">
                          <button type="button" routerLink="/userworkarea" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                          <button *ngIf="!InsuranceExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceVerifyForm.valid || viewMode === 'patient' || !verificationFormEditable">
                            Submit Insurance Info
                          </button>
                          <button *ngIf="InsuranceExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceVerifyForm.valid || viewMode === 'patient' || !verificationFormEditable">
                            Update
                          </button>
                          &lt;!&ndash; Toggle Button &ndash;&gt;
                          <div class="toggle-switch">
                            <label class="switch">
                              <input type="checkbox" (change)="checkInsuranceAllFieldsStatus()" [checked]="allFieldsFilled" [disabled]="true">
                              <span class="slider"></span>
                            </label>
                            <span class="toggle-status-text">
                                {{ allFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                          </div>
                        </div>
                      </form>

                    </mat-tab>
                    &lt;!&ndash;Max & Deductible&ndash;&gt;
                    <mat-tab *ngIf="!shortFormSelected" label="Max Deductible">
                      &lt;!&ndash;  Insurance Form&ndash;&gt;
                      <form [formGroup]="pInsuranceForm" (ngSubmit)="onSubmitMaxDeductible()">
                        <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                          <table mat-table [dataSource]="maxData" class="full-width-table" [ngClass]="{'disabled-table': !isEditable}">
                            &lt;!&ndash; Procedure Name Column &ndash;&gt;
                            <ng-container matColumnDef="maxName">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column procedure-header" (mousedown)="startResize($event, 'maxName')"> Max & Deductible Name </th>
                              <td mat-cell *matCellDef="let maxName; let i = index" class="procedure-name">
                                {{ maxName.name }}
                              </td>
                            </ng-container>

                            &lt;!&ndash; Max Input Column &ndash;&gt;
                            <ng-container matColumnDef="maxInput">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'maxInput')"> Max & Deductible Input </th>
                              <td mat-cell *matCellDef="let maxInput; let i = index" [ngClass]="{ 'highlight-empty': isMaxFormInitialized && !maximumInput.at(i).get('maxInput')?.value }">
                                <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="maximumInput.at(i).get('maxInput')">
                                  <mat-placeholder class="text-center">Enter Procedures</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash;MAX Coverage Column &ndash;&gt;
                            <ng-container matColumnDef="maxCoverage">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'maxCoverage')"> Coverage </th>
                              <td mat-cell *matCellDef="let maxInput; let i = index">
                                <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="maximumInput.at(i).get('maxCoverage')">
                                  <mat-placeholder class="text-center">Enter Coverage</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>
                            &lt;!&ndash; MAX Plan Period Column &ndash;&gt;
                            <ng-container matColumnDef="maxPlan">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'maxPlan')"> Plan Period </th>
                              <td mat-cell *matCellDef="let maxInput; let i = index">
                                <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="maximumInput.at(i).get('maxPlan')">
                                  <mat-placeholder class="text-center">Enter Plan Period</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>
                            &lt;!&ndash; MAX Service Column &ndash;&gt;
                            <ng-container matColumnDef="maxService">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'maxService')"> Service Type </th>
                              <td mat-cell *matCellDef="let maxInput; let i = index" >
                                <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="maximumInput.at(i).get('maxService')">
                                  <mat-placeholder class="text-center">Enter Service Type</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Table Headers and Rows &ndash;&gt;
                            <tr mat-header-row *matHeaderRowDef="maxColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: maxColumns;"></tr>
                          </table>
                        </fieldset>
                        &lt;!&ndash; Buttons for submit and cancel &ndash;&gt;
                        <div class="form-buttons mt-2">
                          <button type="button" routerLink="/userworkarea"
                                  class="btn btn-secondary float-end  waves-effect waves-light btn-sm">Cancel</button>
                          <button *ngIf="!dataExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit"
                                  [disabled]="!pInsuranceForm.valid || viewMode === 'patient' || !verificationFormEditable">Add Max & Deductible
                          </button>
                          <button *ngIf="dataExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit"
                                  [disabled]="!pInsuranceForm.valid || viewMode === 'patient' || !verificationFormEditable">Update
                          </button>
                          &lt;!&ndash; Toggle Button &ndash;&gt;
                          <div class="toggle-switch">
                            <label class="switch">
                              <input type="checkbox" (change)="checkMaxAllFieldsStatus()" [checked]="allMaxFieldsFilled" [disabled]="true">
                              <span class="slider"></span>
                            </label>
                            <span class="toggle-status-text">
                                {{ allMaxFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                          </div>
                        </div>
                      </form>
                    </mat-tab>
                    &lt;!&ndash;Co-Insurance&ndash;&gt;
                    <mat-tab *ngIf="!shortFormSelected" label="Co Insurance">

                      <form [formGroup]="coinsuranceForm" (ngSubmit)="onSubmitCoinsurance()" class="full-width-form">
                        <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                          <table mat-table [dataSource]="coinsuranceData" class="full-width-table">
                            &lt;!&ndash; Procedure Column &ndash;&gt;
                            <ng-container matColumnDef="coinsurance">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column coinsurance-header" (mousedown)="startResize($event, 'coinsurance')"> CoInsurance </th>
                              <td mat-cell *matCellDef="let coinsurance; let i = index" class="coinsurance-name">
                                {{ coinsurance.serviceName }}
                              </td>
                            </ng-container>

                            &lt;!&ndash; Coverage Level Column &ndash;&gt;
                            &lt;!&ndash;                          <ng-container matColumnDef="coverageLevel">&ndash;&gt;
                            &lt;!&ndash;                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'coverageLevel')"> Coverage </th>&ndash;&gt;
                            &lt;!&ndash;                            <td mat-cell *matCellDef="let coverageLevel; let i = index" [ngClass]="{ 'highlight-empty': isCoFormInitialized && !coinsurances.at(i).get('coverageLevel')?.value }">&ndash;&gt;
                            &lt;!&ndash;                                <mat-form-field class="full-width-input spaced-field small-placeholder">&ndash;&gt;
                            &lt;!&ndash;                                    <input matInput [formControl]="coinsurances.at(i).get('coverageLevel')" [disabled]="!isEditable">&ndash;&gt;
                            &lt;!&ndash;                                    <mat-placeholder>coverage Level</mat-placeholder>&ndash;&gt;
                            &lt;!&ndash;                                </mat-form-field>&ndash;&gt;
                            &lt;!&ndash;                            </td>&ndash;&gt;
                            &lt;!&ndash;                          </ng-container>&ndash;&gt;

                            &lt;!&ndash; Percent Column &ndash;&gt;
                            <ng-container matColumnDef="percent">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'percent')"> Percent </th>
                              <td mat-cell *matCellDef="let percent; let i = index" [ngClass]="{ 'highlight-empty': isCoFormInitialized && !coinsurances.at(i).get('percent')?.value }">
                                <mat-form-field class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="coinsurances.at(i).get('percent')" [disabled]="!isEditable">
                                  <mat-placeholder>Percent</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Message Column &ndash;&gt;
                            &lt;!&ndash;                          <ng-container matColumnDef="message">&ndash;&gt;
                            &lt;!&ndash;                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'message')"> Message</th>&ndash;&gt;
                            &lt;!&ndash;                            <td mat-cell *matCellDef="let percent; let i = index" [ngClass]="{ 'highlight-empty': isCoFormInitialized && !coinsurances.at(i).get('message')?.value }">&ndash;&gt;
                            &lt;!&ndash;                                <mat-form-field class="full-width-input spaced-field small-placeholder">&ndash;&gt;
                            &lt;!&ndash;                                      <textarea matInput&ndash;&gt;
                            &lt;!&ndash;                                                [formControl]="coinsurances.at(i).get('message')"&ndash;&gt;
                            &lt;!&ndash;                                                rows="3"&ndash;&gt;
                            &lt;!&ndash;                                                cdkTextareaAutosize&ndash;&gt;
                            &lt;!&ndash;                                                cdkAutosizeMinRows="3"&ndash;&gt;
                            &lt;!&ndash;                                                cdkAutosizeMaxRows="5"&ndash;&gt;
                            &lt;!&ndash;                                                (focus)="onFocus(i)"&ndash;&gt;
                            &lt;!&ndash;                                                (blur)="onBlur(i)"&ndash;&gt;
                            &lt;!&ndash;                                                [disabled]="!isEditable">&ndash;&gt;
                            &lt;!&ndash;                                      </textarea>&ndash;&gt;
                            &lt;!&ndash;                                    <mat-label *ngIf="!isFocused[i] && !coinsurances.at(i).get('message')?.value">Enter Message</mat-label>&ndash;&gt;
                            &lt;!&ndash;                                </mat-form-field>&ndash;&gt;
                            &lt;!&ndash;                            </td>&ndash;&gt;
                            &lt;!&ndash;                          </ng-container>&ndash;&gt;

                            &lt;!&ndash; Table Headers and Rows &ndash;&gt;
                            <tr mat-header-row *matHeaderRowDef="coinsuranceColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: coinsuranceColumns;"></tr>
                          </table>
                        </fieldset>
                        &lt;!&ndash; Buttons for submit and cancel &ndash;&gt;
                        <div class="form-buttons mt-2">
                          <button type="button" routerLink="/userworkarea" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                          <button *ngIf="!coinsuranceExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceCoveragesForm.valid || !isEditable || isFormDisabled || viewMode === 'patient'|| !verificationFormEditable">
                            Add Co Insurance
                          </button>
                          <button *ngIf="coinsuranceExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceCoveragesForm.valid || !isEditable || isFormDisabled || viewMode === 'patient'|| !verificationFormEditable">
                            Update Co Insurance
                          </button>
                          &lt;!&ndash; Toggle Button &ndash;&gt;
                          <div class="toggle-switch">
                            <label class="switch">
                              <input type="checkbox" (change)="checkCoInsAllFieldsStatus()" [checked]="allCoFieldsFilled" [disabled]="true">
                              <span class="slider"></span>
                            </label>
                            <span class="toggle-status-text">
                                {{ allCoFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                          </div>
                        </div>
                      </form>

                    </mat-tab>
                    &lt;!&ndash;Coverage & Freq&ndash;&gt;
                    <mat-tab *ngIf="!shortFormSelected" label="Coverages & Frequencies">

                      <form [formGroup]="insuranceCoveragesForm" (ngSubmit)="onSubmitCoverage()" class="full-width-form">
                        <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                          <table mat-table [dataSource]="coveragesData" class="full-width-table">
                            &lt;!&ndash; Procedure Column &ndash;&gt;
                            <ng-container matColumnDef="procedure">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'procedure')"> Procedure </th>
                              <td mat-cell *matCellDef="let procedure; let i = index" class="procedure-name">
                                {{ procedure.serviceName }}
                                &lt;!&ndash;                                <mat-form-field class="full-width-input spaced-field small-placeholder">&ndash;&gt;
                                &lt;!&ndash;                                  <input matInput [formControl]="procedures.at(i).get('procedure')"  />&ndash;&gt;
                                &lt;!&ndash;                                </mat-form-field>&ndash;&gt;
                              </td>
                            </ng-container>

                            &lt;!&ndash; Coverage Column &ndash;&gt;
                            &lt;!&ndash;                            <ng-container matColumnDef="coverage">&ndash;&gt;
                            &lt;!&ndash;                              <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'coverage')"> Coverage </th>&ndash;&gt;
                            &lt;!&ndash;                              <td mat-cell *matCellDef="let procedure; let i = index" [ngClass]="{ 'highlight-empty': isCoverageFormInitialized && !procedures.at(i).get('coverage')?.value }">&ndash;&gt;
                            &lt;!&ndash;                                <mat-form-field  class="full-width-input spaced-field small-placeholder">&ndash;&gt;
                            &lt;!&ndash;                                  <input matInput [formControl]="procedures.at(i).get('coverage')">&ndash;&gt;
                            &lt;!&ndash;                                  <mat-placeholder>Enter Coverage</mat-placeholder>&ndash;&gt;
                            &lt;!&ndash;                                </mat-form-field>&ndash;&gt;
                            &lt;!&ndash;                              </td>&ndash;&gt;
                            &lt;!&ndash;                            </ng-container>&ndash;&gt;

                            &lt;!&ndash; Percent Column &ndash;&gt;
                            <ng-container matColumnDef="percentage">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'percentage')"> Percent </th>
                              <td mat-cell *matCellDef="let procedure; let i = index" [ngClass]="{ 'highlight-empty': isCoverageFormInitialized && !procedures.at(i).get('percentage')?.value }">
                                <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="procedures.at(i).get('percentage')">
                                  <mat-placeholder>Enter Percent</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Frequency Column &ndash;&gt;
                            <ng-container matColumnDef="frequency">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'frequency')"> Frequency </th>
                              <td mat-cell *matCellDef="let procedure; let i = index" [ngClass]="{ 'highlight-empty': isCoverageFormInitialized && !procedures.at(i).get('frequency')?.value }">
                                <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="procedures.at(i).get('frequency')">
                                  <mat-placeholder>Enter Frequency</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Guidelines Column &ndash;&gt;
                            <ng-container matColumnDef="guidelines">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'guidelines')"> Guidelines </th>
                              <td mat-cell *matCellDef="let procedure; let i = index" [ngClass]="{ 'highlight-empty': isCoverageFormInitialized && !procedures.at(i).get('guidelines')?.value }">
                                <mat-form-field class="full-width-input spaced-field-message small-placeholder">
                                  &lt;!&ndash;                                  <input matInput [formControl]="procedures.at(i).get('guidelines')" >&ndash;&gt;
                                  &lt;!&ndash;                                  <mat-label>Enter Guidelines</mat-label>&ndash;&gt;
                                  <textarea matInput [formControl]="procedures.at(i).get('guidelines')" rows="3" cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" (focus)="onFocus(i)"
                                            (blur)="onBlur(i)"></textarea>
                                  <mat-label *ngIf="!isFocused[i] && !procedures.at(i).get('guidelines')?.value">Enter Guidelines</mat-label>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Age Column &ndash;&gt;
                            <ng-container matColumnDef="agelimit">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header"
                                  (mousedown)="startResize($event, 'agelimit')">
                                Age Limit
                              </th>
                              <td mat-cell *matCellDef="let procedure; let i = index"
                                  [ngClass]="{ 'highlight-empty': isCoverageFormInitialized &&
                                            (!procedures.at(i).get('agelowvalue')?.value) }">

                                <div class="age-limit-container">
                                  &lt;!&ndash; Low Age Input &ndash;&gt;
                                  <mat-form-field class="full-width-input spaced-field small-placeholder">
                                    <input matInput
                                           [formControl]="procedures.at(i).get('agelowvalue')"
                                           placeholder="Age">
                                  </mat-form-field>

                                  &lt;!&ndash;                                          <span class="age-limit-separator">|</span>&ndash;&gt;

                                  &lt;!&ndash; High Age Input &ndash;&gt;
                                  &lt;!&ndash;<mat-form-field class="full-width-input spaced-field small-placeholder">
                                      <input matInput
                                             [formControl]="procedures.at(i).get('agehighvalue')"
                                             placeholder="High Age" type="number" min="0">
                                  </mat-form-field>&ndash;&gt;
                                </div>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Table Headers and Rows &ndash;&gt;
                            <tr mat-header-row *matHeaderRowDef="coverageColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: coverageColumns;"></tr>
                          </table>
                        </fieldset>
                        &lt;!&ndash; Buttons for submit and cancel &ndash;&gt;
                        <div class="form-buttons mt-2">
                          <button type="button" routerLink="/userworkarea" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                          <button *ngIf="!coverageExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceCoveragesForm.valid || !isEditable || isFormDisabled || viewMode === 'patient' || !verificationFormEditable">
                            Add Coverages
                          </button>
                          <button *ngIf="coverageExists " class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceCoveragesForm.valid || !isEditable || isFormDisabled || viewMode === 'patient' || !verificationFormEditable">
                            Update Coverages
                          </button>
                          &lt;!&ndash; Toggle Button &ndash;&gt;
                          <div class="toggle-switch">
                            <label class="switch">
                              <input type="checkbox" (change)="checkCoverageInsAllFieldsStatus()" [checked]="allCoverageFieldsFilled" [disabled]="true">
                              <span class="slider"></span>
                            </label>
                            <span class="toggle-status-text">
                                {{ allCoverageFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                          </div>
                        </div>
                      </form>

                    </mat-tab>
                    &lt;!&ndash;Ortho&ndash;&gt;
                    <mat-tab *ngIf="!shortFormSelected" label="Ortho">

                      <form [formGroup]="orthoForm" (ngSubmit)="onSubmitOrtho()" class="full-width-form">
                        <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                          <table mat-table [dataSource]="orthoData" class="full-width-table">
                            &lt;!&ndash; Ortho Column &ndash;&gt;
                            <ng-container matColumnDef="ortho">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column ortho-header" (mousedown)="startResize($event, 'ortho')"> Ortho Procedure </th>
                              <td mat-cell *matCellDef="let ortho; let i = index" class="procedure-name">
                                {{ ortho.serviceName }}
                                &lt;!&ndash;                                          <mat-form-field class="full-width-input spaced-field small-placeholder">&ndash;&gt;
                                &lt;!&ndash;                                              <input matInput [formControl]="orthos.at(i).get('ortho')" placeholder="Enter Procedure"/>&ndash;&gt;
                                &lt;!&ndash;                                          </mat-form-field>&ndash;&gt;
                              </td>
                            </ng-container>

                            &lt;!&ndash; Ortho Coverage Column &ndash;&gt;
                            &lt;!&ndash;                                  <ng-container matColumnDef="orthoCoverage">&ndash;&gt;
                            &lt;!&ndash;                                      <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'orthoCoverage')"> Ortho Coverage </th>&ndash;&gt;
                            &lt;!&ndash;                                      <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoCoverage')?.value }">&ndash;&gt;
                            &lt;!&ndash;                                          <mat-form-field class="full-width-input spaced-field small-placeholder">&ndash;&gt;
                            &lt;!&ndash;                                              <input matInput [formControl]="orthos.at(i).get('orthoCoverage')" [attr.disabled]="!isEditable">&ndash;&gt;
                            &lt;!&ndash;                                              <mat-placeholder>Enter Coverage</mat-placeholder>&ndash;&gt;
                            &lt;!&ndash;                                          </mat-form-field>&ndash;&gt;
                            &lt;!&ndash;                                      </td>&ndash;&gt;
                            &lt;!&ndash;                                  </ng-container>&ndash;&gt;

                            &lt;!&ndash; Ortho Percentage Column &ndash;&gt;
                            <ng-container matColumnDef="orthoPercent">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'orthoPercent')"> Ortho Percent </th>
                              <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoPercent')?.value }">
                                <mat-form-field class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="orthos.at(i).get('orthoPercent')" [attr.disabled]="!isEditable">
                                  <mat-placeholder>Enter Percentage</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Ortho Frequency Column &ndash;&gt;
                            <ng-container matColumnDef="orthoFrequency">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'orthoFrequency')"> Ortho Frequency </th>
                              <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoFrequency')?.value }">
                                <mat-form-field class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="orthos.at(i).get('orthoFrequency')" [attr.disabled]="!isEditable">
                                  <mat-placeholder>Enter Frequency</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Ortho History Column &ndash;&gt;
                            &lt;!&ndash;                                  <ng-container matColumnDef="orthoHistory">&ndash;&gt;
                            &lt;!&ndash;                                      <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'orthoHistory')"> Ortho History </th>&ndash;&gt;
                            &lt;!&ndash;                                      <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoHistory')?.value }">&ndash;&gt;
                            &lt;!&ndash;                                          <mat-form-field class="full-width-input spaced-field small-placeholder">&ndash;&gt;
                            &lt;!&ndash;                                              <input matInput [formControl]="orthos.at(i).get('orthoHistory')" [attr.disabled]="!isEditable">&ndash;&gt;
                            &lt;!&ndash;                                              <mat-placeholder>Enter History</mat-placeholder>&ndash;&gt;
                            &lt;!&ndash;                                          </mat-form-field>&ndash;&gt;
                            &lt;!&ndash;                                      </td>&ndash;&gt;
                            &lt;!&ndash;                                  </ng-container>&ndash;&gt;

                            &lt;!&ndash; Guidelines Column &ndash;&gt;
                            <ng-container matColumnDef="orthoGuidelines">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'orthoGuidelines')"> Guidelines </th>
                              <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoGuidelines')?.value }">
                                <mat-form-field class="full-width-input spaced-field-message small-placeholder">
                    <textarea matInput
                              [formControl]="orthos.at(i).get('orthoGuidelines')"
                              rows="3"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="3"
                              cdkAutosizeMaxRows="5"
                              (focus)="onFocus(i)"
                              (blur)="onBlur(i)"
                              [attr.disabled]="!isEditable"></textarea>
                                  <mat-label *ngIf="!isFocused[i] && !orthos.at(i).get('orthoGuidelines')?.value">Enter Guidelines</mat-label>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Table Headers and Rows &ndash;&gt;
                            <tr mat-header-row *matHeaderRowDef="orthoColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: orthoColumns;"></tr>
                          </table>
                        </fieldset>
                        &lt;!&ndash; Buttons and toggle remain enabled &ndash;&gt;
                        <div class="form-buttons mt-2">
                          <button type="button" routerLink="/userworkarea" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                          <button *ngIf="!orthoExists"
                                  class="btn btn-outline-light btn-sm px-5 float-right"
                                  mat-raised-button
                                  color="primary"
                                  type="submit"
                                  [disabled]="!orthoForm.valid || !isEditable || isFormDisabled || viewMode === 'patient' || !verificationFormEditable">
                            Add Ortho
                          </button>
                          <button *ngIf="orthoExists"
                                  class="btn btn-outline-light btn-sm px-5 float-right"
                                  mat-raised-button
                                  color="primary"
                                  type="submit"
                                  [disabled]="!orthoForm.valid || !isEditable || isFormDisabled || viewMode === 'patient' || !verificationFormEditable">
                            Update Ortho
                          </button>
                          <div class="toggle-switch">
                            <label class="switch">
                              <input type="checkbox"
                                     (change)="checkOrthoAllFieldsStatus()"
                                     [checked]="allOrthoFieldsFilled" [disabled]="true">
                              <span class="slider"></span>
                            </label>
                            <span class="toggle-status-text">
                {{ allOrthoFieldsFilled ? 'Verified' : 'Pending Verification' }}
            </span>
                          </div>
                        </div>
                      </form>

                    </mat-tab>
                    &lt;!&ndash;History&ndash;&gt;
                    <mat-tab *ngIf="!shortFormSelected" label="History">
                      <form [formGroup]="historyForm" (ngSubmit)="onSubmitHistory()" class="full-width-form">
                        <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                          <table mat-table [dataSource]="historyData" class="full-width-table">
                            &lt;!&ndash; History question Column &ndash;&gt;
                            <ng-container matColumnDef="historyName">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column procedure-header" (mousedown)="startResize($event, 'historyName')"> History Name </th>
                              <td mat-cell *matCellDef="let historyName; let i = index" class="procedure-name">
                                {{ historyName.serviceName }}
                                &lt;!&ndash;                                <mat-form-field class="full-width-input spaced-field small-placeholder">&ndash;&gt;
                                &lt;!&ndash;                                    <input matInput [formControl]="historiesInput.at(i).get('historyName')" />&ndash;&gt;
                                &lt;!&ndash;                                </mat-form-field>&ndash;&gt;
                              </td>
                            </ng-container>

                            &lt;!&ndash; History Input Column &ndash;&gt;
                            <ng-container matColumnDef="historyInput">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'historyInput')"> History Input </th>
                              <td mat-cell *matCellDef="let historyInput; let i = index" [ngClass]="{ 'highlight-empty': isHistoryFormInitialized && !historiesInput.at(i).get('historyInput')?.value }">
                                <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="historiesInput.at(i).get('historyInput')">
                                  <mat-placeholder class="text-center">Enter Histories</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash;History Eligibility&ndash;&gt;
                            <ng-container matColumnDef="historyEligibility">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'historyInput')"> Eligibility </th>
                              <td mat-cell *matCellDef="let historyEligibility; let i = index" [ngClass]="{ 'highlight-empty': isHistoryFormInitialized && !historiesInput.at(i).get('historyEligibility')?.value }">
                                <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="historiesInput.at(i).get('historyEligibility')">
                                  <mat-placeholder class="text-center">Enter Histories</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Table Headers and Rows &ndash;&gt;
                            <tr mat-header-row *matHeaderRowDef="historyColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: historyColumns;"></tr>
                          </table>
                        </fieldset>

                        &lt;!&ndash; Buttons for submit and cancel &ndash;&gt;
                        <div class="form-buttons mt-2">
                          <button type="button" routerLink="/userworkarea" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                          <button *ngIf="!historyExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!historyForm.valid || !isEditable || viewMode === 'patient' || !verificationFormEditable">
                            Submit History Info
                          </button>
                          <button *ngIf="historyExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!historyForm.valid || !isEditable || viewMode === 'patient' || !verificationFormEditable">
                            Update
                          </button>
                          &lt;!&ndash; Toggle Button &ndash;&gt;
                          <div class="toggle-switch">
                            <label class="switch">
                              <input type="checkbox" (change)="checkHistAllFieldsStatus()" [checked]="allHistFieldsFilled" [disabled]="true">
                              <span class="slider"></span>
                            </label>
                            <span class="toggle-status-text">
                                {{ allHistFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                          </div>
                        </div>
                      </form>
                    </mat-tab>

                    <mat-tab *ngIf="shortFormSelected" label="Short Form">
                      <form [formGroup]="historyForm" (ngSubmit)="onSubmitHistory()" class="full-width-form">
                        <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                          <table mat-table [dataSource]="historyData" class="full-width-table">
                            &lt;!&ndash; Procedure Name Column &ndash;&gt;
                            <ng-container matColumnDef="historyName">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column procedure-header" (mousedown)="startResize($event, 'historyName')"> History Name </th>
                              <td mat-cell *matCellDef="let historyName; let i = index" class="procedure-name">
                                {{ historyName.serviceName }}
                                &lt;!&ndash;                                <mat-form-field class="full-width-input spaced-field small-placeholder">&ndash;&gt;
                                &lt;!&ndash;                                    <input matInput [formControl]="historiesInput.at(i).get('historyName')" />&ndash;&gt;
                                &lt;!&ndash;                                </mat-form-field>&ndash;&gt;
                              </td>
                            </ng-container>

                            &lt;!&ndash; Procedure Input Column &ndash;&gt;
                            <ng-container matColumnDef="historyInput">
                              <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'historyInput')"> History Input </th>
                              <td mat-cell *matCellDef="let historyInput; let i = index" [ngClass]="{ 'highlight-empty': isHistoryFormInitialized && !historiesInput.at(i).get('historyInput')?.value }">
                                <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                  <input matInput [formControl]="historiesInput.at(i).get('historyInput')">
                                  <mat-placeholder class="text-center">Enter Histories</mat-placeholder>
                                </mat-form-field>
                              </td>
                            </ng-container>

                            &lt;!&ndash; Table Headers and Rows &ndash;&gt;
                            <tr mat-header-row *matHeaderRowDef="historyColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: historyColumns;"></tr>
                          </table>
                        </fieldset>
                        &lt;!&ndash; Buttons for submit and cancel &ndash;&gt;
                        <div class="form-buttons mt-2">
                          <button type="button" routerLink="/userworkarea" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                          <button *ngIf="!historyExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!historyForm.valid || !isEditable || viewMode === 'patient' || !verificationFormEditable">
                            Submit History Info
                          </button>
                          <button *ngIf="historyExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!historyForm.valid || !isEditable || viewMode === 'patient' || !verificationFormEditable">
                            Update
                          </button>
                          &lt;!&ndash; Toggle Button &ndash;&gt;
                          <div class="toggle-switch">
                            <label class="switch">
                              <input type="checkbox" (change)="checkHistAllFieldsStatus()" [checked]="allHistFieldsFilled" [disabled]="true">
                              <span class="slider"></span>
                            </label>
                            <span class="toggle-status-text">
                                {{ allHistFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                          </div>
                        </div>
                      </form>
                    </mat-tab>

                  </mat-tab-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->

      <div class="col-xl-12 col-md-12 mb-2" *ngIf="!notEligilbleSelected">
        <div class="card verification-workspace-card layout-loading-host h-100 py-2">
          <div
            *ngIf="isChangingLayout"
            class="layout-loading-overlay"
            role="status"
            aria-live="polite">

            <div class="layout-loading-card">
              <div class="layout-loader"></div>

              <div class="layout-loading-content">
                <span class="layout-loading-title">
                  Changing view
                </span>

                <span class="layout-loading-message">
                  {{
                    isVertical
                      ? 'Preparing tab view...'
                      : 'Loading all verification sections...'
                  }}
                </span>
              </div>
            </div>
          </div>
          <div class="card-body pt-1">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-primary mb-1">

                  <div class="verification-layout-toolbar">
                  <div class="layout-toolbar-title">
                    <span class="layout-title">Verification Details</span>

                    <span class="layout-description">
                      {{
                        isChangingLayout
                          ? 'Preparing verification layout...'
                          : isVertical
                            ? 'All sections displayed on one page'
                            : 'Sections displayed in separate tabs'
                      }}
                    </span>
                  </div>

                  <div class="verification-domain-switch" role="group" aria-label="Verification domain">
                     <span class="verification-domain-label">Domain</span>
                     <button type="button" [class.active]="benefitDomain === 'DENTAL'"
                             [attr.aria-pressed]="benefitDomain === 'DENTAL'"
                             (click)="changeBenefitDomain('DENTAL')">Dental</button>
                     <button type="button" [class.active]="benefitDomain === 'MEDICAL'"
                             [attr.aria-pressed]="benefitDomain === 'MEDICAL'"
                             (click)="changeBenefitDomain('MEDICAL')">Medical</button>
                   </div>
                   <div class="layout-view-switch">
                    <span
                      class="layout-option"
                      [class.active]="!isVertical">
                      Tab View
                    </span>

                    <label class="view-switch">
                      <input
                        type="checkbox"
                        [checked]="isVertical"
                        [disabled]="isChangingLayout"
                        (change)="onLayoutToggle($event.target.checked)"
                        aria-label="Switch between tab view and single-page view">

                      <span class="view-slider"></span>
                    </label>

                    <span
                      class="layout-option"
                      [class.active]="isVertical">
                      Single Page
                    </span>
                  </div>
                </div>

                  <div *ngIf="activeAuditChangeRequest" class="domain-question-notice audit-changes-notice" role="status">
                    <strong>{{benefitDomain === 'DENTAL' ? 'Dental' : 'Medical'}} audit: Changes Requested.</strong>
                    {{activeAuditChangeRequest.failed_question_count || 0}} question(s) flagged. Correct the answers and save the plan to resubmit this domain's audit.
                  </div>
                  <div *ngIf="isQuestionReloading" class="domain-question-notice" role="status">Loading {{benefitDomain}} questions...</div>
                  <div *ngIf="!isQuestionReloading && questionLoadError" class="domain-question-notice error" role="alert">{{questionLoadError}}</div>
                  <div *ngIf="!isQuestionReloading && !questionLoadError && noQuestionsForDomain" class="domain-question-notice" role="status">
                    No {{benefitDomain}} questions configured for this office, form type and plan creation.
                  </div>
                  <!-- DEFAULT: TABS -->
                  <ng-container *ngIf="!isVertical; else verticalView">
                    <div class="verification-tabs-shell">
                      <mat-tab-group animationDuration="0ms" [dynamicHeight]="false">
                        <mat-tab *ngIf="!shortFormSelected" label="Appointment Info">
                          <ng-template matTabContent>
                            <ng-container [ngTemplateOutlet]="tplAppointmentInfo"></ng-container>
                          </ng-template>
                        </mat-tab>

                        <mat-tab *ngIf="!shortFormSelected" label="Max Deductible">
                          <ng-template matTabContent>
                            <ng-container [ngTemplateOutlet]="tplMaxDeductible"></ng-container>
                          </ng-template>
                        </mat-tab>

                        <!-- Repeat for other tabs -->
                        <mat-tab *ngIf="!shortFormSelected" label="Co Insurance">
                          <ng-template matTabContent>
                            <ng-container [ngTemplateOutlet]="tplCoInsurance"></ng-container>
                          </ng-template>
                        </mat-tab>

                        <mat-tab *ngIf="!shortFormSelected" label="Coverages & Frequencies">
                          <ng-template matTabContent>
                            <ng-container [ngTemplateOutlet]="tplCoverageFreq"></ng-container>
                          </ng-template>
                        </mat-tab>

                        <mat-tab *ngIf="!shortFormSelected" label="Ortho">
                          <ng-template matTabContent>
                            <ng-container [ngTemplateOutlet]="tplOrtho"></ng-container>
                          </ng-template>
                        </mat-tab>

                        <mat-tab *ngIf="!shortFormSelected" label="History">
                          <ng-template matTabContent>
                            <ng-container [ngTemplateOutlet]="tplHistory"></ng-container>
                          </ng-template>
                        </mat-tab>

                        <mat-tab *ngIf="shortFormSelected" label="Short Form">
                          <ng-container [ngTemplateOutlet]="tplShortForm"></ng-container>
                        </mat-tab>
                      </mat-tab-group>
                    </div>
                  </ng-container>
                  <!-- User Work Area actions -->
                  <div class="verification-floating-footer">
                    <button
                      type="button"
                      class="btn btn-secondary verification-back-btn"
                      (click)="goBack()">
                      Back
                    </button>

                    <div class="verification-footer-actions" *ngIf="isEditable">
                      <button
                        type="button"
                        class="btn btn-primary verification-add-update-btn"
                        (click)="onallSave()"
                        [disabled]="viewMode === 'patient' || !verificationFormEditable">
                        {{ allFieldsFilled ? 'Update All' : 'Add All' }}
                      </button>                      
                    </div>
                  </div>

                  <!-- VERTICAL: STACKED SECTIONS -->
                  <ng-template #verticalView>
                    <div class="vertical-sections">
                      <section class="v-section">
                        <h4 class="v-title">Appointment Info</h4>
                        <ng-container [ngTemplateOutlet]="tplAppointmentInfo"></ng-container>
                      </section>

                      <section class="v-section">
                        <h4 class="v-title">Max Deductible</h4>
                        <ng-container [ngTemplateOutlet]="tplMaxDeductible"></ng-container>
                      </section>

                      <!-- Repeat for other sections -->
                      <section class="v-section">
                        <h4 class="v-title">Co Insurance</h4>
                        <ng-container [ngTemplateOutlet]="tplCoInsurance"></ng-container>
                      </section>

                      <section class="v-section">
                        <h4 class="v-title">Coverages & Frequencies</h4>
                        <ng-container [ngTemplateOutlet]="tplCoverageFreq"></ng-container>
                      </section>

                      <section class="v-section">
                        <h4 class="v-title">Ortho</h4>
                        <ng-container [ngTemplateOutlet]="tplOrtho"></ng-container>
                      </section>

                      <section class="v-section">
                        <h4 class="v-title">History</h4>
                        <ng-container [ngTemplateOutlet]="tplHistory"></ng-container>
                      </section>

                      <section class="v-section" *ngIf="shortFormSelected">
                        <h6 class="v-title">Short Form</h6>
                        <ng-container [ngTemplateOutlet]="tplShortForm"></ng-container>
                      </section>
                    </div>
                    <!-- <div class="vertical-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        routerLink="/userworkarea">
                        Cancel
                      </button>

                      <button
                        type="button"
                        class="btn btn-primary"
                        (click)="onVerticalSave()"
                        [disabled]="viewMode === 'patient' || !verificationFormEditable || !verificationFormEditable">
                        {{ allFieldsFilled ? 'Update All' : 'Add All' }}
                      </button>
                    </div> -->
                  </ng-template>

                  <!-- ================== TEMPLATES (reuse bodies) ================== -->
                  <ng-template #tplAppointmentInfo>
                    <!-- your existing Appointment Info form/table exactly as-is -->
                    <form [formGroup]="insuranceVerifyForm" (ngSubmit)="onSubmitInsurance()" class="full-width-form">
                      <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable ">
                        <table mat-table [dataSource]="proceduresData" [trackBy]="trackById" class="full-width-table">
                          <!-- Procedure Name Column -->
                          <ng-container matColumnDef="procedureName">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column procedure-header" (mousedown)="startResize($event, 'procedureName')"> Procedure Name </th>
                            <td mat-cell *matCellDef="let procedureName; let i = index" class="procedure-name">
                              {{ procedureName.name }}
                              <span *ngIf="isAuditFailed(procedureName)" class="audit-fail-marker"
                                    [matTooltip]="auditFailureTooltip(procedureName)" matTooltipPosition="above"
                                    matTooltipClass="audit-failure-tooltip" aria-label="Audit correction required">
                                <i class="fa-solid fa-circle-exclamation"></i> Review
                              </span>
                            </td>
                          </ng-container>

                          <!-- Procedure Input Column -->
                          <!-- <ng-container matColumnDef="procedureInput">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'procedureInput')"> Procedure Input </th>
                            <td mat-cell *matCellDef="let procedureInput; let i = index" [ngClass]="{ 'highlight-empty': isPatientFormInitialized && !proceduresInput.at(i).get('procedureInput')?.value }">
                              <mat-form-field  class="full-width-input spaced-field small-placeholder" >
                                <input matInput [formControl]="proceduresInput.at(i).get('procedureInput')">
                                <mat-placeholder class="text-center">Enter Procedures</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container> -->
                          <!-- Procedure Input Column -->
                          <ng-container matColumnDef="procedureInput">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2"
                                (mousedown)="startResize($event, 'procedureInput')">
                              Procedure Input
                            </th>

                            <td mat-cell *matCellDef="let row; let i = index"
                                [ngClass]="{ 'highlight-empty': isPatientFormInitialized && !proceduresInput.at(i).get('procedureInput')?.value }">

                              <!-- If the question is INSURANCE NAME -> show dropdown -->
                              <ng-container *ngIf="isInsuranceName(row?.name); else defaultTextField">
                                <mat-form-field class="full-width-input spaced-field small-placeholder">
                                  <mat-label>Insurance Name</mat-label>
                                  <mat-select  data-control="procedureInput" [formControl]="proceduresInput.at(i).get('procedureInput')">
                                    <mat-option *ngFor="let opt of insuranceNameOptions" [value]="opt">
                                      {{ opt }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </ng-container>

                              <!-- Default text input for all other questions -->
                              <ng-template #defaultTextField>
                                <mat-form-field class="full-width-input spaced-field small-placeholder">
                                  <input matInput data-control="procedureInput" [formControl]="proceduresInput.at(i).get('procedureInput')" [disabled]="isPayerId(row?.name)" />
                                  <mat-placeholder class="text-center">Enter Procedures</mat-placeholder>
                                </mat-form-field>
                              </ng-template>

                            </td>
                          </ng-container>

                          <!-- Table Headers and Rows -->
                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"
                             [class.audit-failed-question-row]="isAuditFailed(row)"
                             [matTooltip]="auditFailureTooltip(row)"
                             [matTooltipDisabled]="!isAuditFailed(row)"
                             matTooltipPosition="above"
                             matTooltipClass="audit-failure-tooltip"
                             (keydown)="onAppointmentRowKeydown($event, i)">
                          </tr>
                        </table>
                      </fieldset>
                      <!-- Buttons for submit and cancel -->
                      <div class="form-buttons mt-2">
                        <button type="button" *ngIf="!isVertical && !isHidden" routerLink="/userworkarea" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                        <button *ngIf="!InsuranceExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceVerifyForm.valid || viewMode === 'patient' || !verificationFormEditable">
                          Submit Insurance Info
                        </button>
                        <button *ngIf="InsuranceExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceVerifyForm.valid || viewMode === 'patient' || !verificationFormEditable">
                          Update
                        </button>
                        <!-- Toggle Button -->
                        <div class="toggle-switch">
                          <label class="switch">
                            <input type="checkbox" (change)="checkInsuranceAllFieldsStatus()" [checked]="allFieldsFilled" [disabled]="true">
                            <span class="slider"></span>
                          </label>
                          <span class="toggle-status-text">
                                {{ allFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                        </div>
                      </div>
                    </form>
                  </ng-template>

                  <ng-template #tplMaxDeductible>
                    <!-- your existing Max Deductible form/table exactly as-is -->
                    <form [formGroup]="pInsuranceForm">
                      <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                        <table mat-table [dataSource]="maxData"  [trackBy]="trackById" class="full-width-table" [ngClass]="{'disabled-table': !isEditable}">
                          <!-- Procedure Name Column -->
                          <ng-container matColumnDef="maxName">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column procedure-header" (mousedown)="startResize($event, 'maxName')"> Max & Deductible Name </th>
                            <td mat-cell *matCellDef="let maxName; let i = index" class="procedure-name">
                              {{ maxName.name }}
                              <span *ngIf="isAuditFailed(maxName)" class="audit-fail-marker"
                                    [matTooltip]="auditFailureTooltip(maxName)" matTooltipPosition="above"
                                    matTooltipClass="audit-failure-tooltip" aria-label="Audit correction required">
                                <i class="fa-solid fa-circle-exclamation"></i> Review
                              </span>
                            </td>
                          </ng-container>

                          <!-- Max Input Column -->
                          <ng-container matColumnDef="maxInput">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'maxInput')"> Max & Deductible Input </th>
                            <td mat-cell *matCellDef="let maxInput; let i = index" [ngClass]="{ 'highlight-empty': isMaxFormInitialized && !maximumInput.at(i).get('maxInput')?.value }">
                              <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                <input matInput data-control="maxInput" [formControl]="maximumInput.at(i).get('maxInput')">
                                <mat-placeholder class="text-center">Enter Procedures</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!--MAX Coverage Column -->
                          <ng-container matColumnDef="maxCoverage">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'maxCoverage')"> Coverage </th>
                            <td mat-cell *matCellDef="let maxInput; let i = index">
                              <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                <input matInput data-control="maxCoverage" [formControl]="maximumInput.at(i).get('maxCoverage')">
                                <mat-placeholder class="text-center">Enter Coverage</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>
                          <!-- MAX Plan Period Column -->
                          <ng-container matColumnDef="maxPlan">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'maxPlan')"> Plan Period </th>
                            <td mat-cell *matCellDef="let maxInput; let i = index">
                              <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                <input matInput data-control="maxPlan" [formControl]="maximumInput.at(i).get('maxPlan')">
                                <mat-placeholder class="text-center">Enter Plan Period</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>
                          <!-- MAX Service Column -->
                          <ng-container matColumnDef="maxService">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'maxService')"> Service Type </th>
                            <td mat-cell *matCellDef="let maxInput; let i = index" >
                              <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                <input matInput data-control="maxService" [formControl]="maximumInput.at(i).get('maxService')">
                                <mat-placeholder class="text-center">Enter Service Type</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Table Headers and Rows -->
                          <tr mat-header-row *matHeaderRowDef="maxColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: maxColumns; let i = index"
                             [class.audit-failed-question-row]="isAuditFailed(row)"
                             [matTooltip]="auditFailureTooltip(row)"
                             [matTooltipDisabled]="!isAuditFailed(row)"
                             matTooltipPosition="above"
                             matTooltipClass="audit-failure-tooltip"
                             (keydown)="onMaxRowKeydown($event, i)">
                          </tr>
                        </table>
                      </fieldset>
                      <!-- Buttons for submit and cancel -->
                      <div class="form-buttons mt-2">
                        <button type="button" routerLink="/userworkarea" *ngIf="!isVertical && !isHidden"
                                class="btn btn-secondary float-end  waves-effect waves-light btn-sm">Cancel</button>
                        <button *ngIf="!dataExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit"
                                [disabled]="!pInsuranceForm.valid || viewMode === 'patient' || !verificationFormEditable">Add Max & Deductible
                        </button>
                        <button *ngIf="dataExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit"
                                [disabled]="!pInsuranceForm.valid || viewMode === 'patient' || !verificationFormEditable">Update
                        </button>
                        <!-- Toggle Button -->
                        <div class="toggle-switch">
                          <label class="switch">
                            <input type="checkbox" (change)="checkMaxAllFieldsStatus()" [checked]="allMaxFieldsFilled" [disabled]="true">
                            <span class="slider"></span>
                          </label>
                          <span class="toggle-status-text">
                                {{ allMaxFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                        </div>
                      </div>
                    </form>
                  </ng-template>

                  <ng-template #tplCoInsurance>
                    <form [formGroup]="coinsuranceForm" class="full-width-form">
                      <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                        <table mat-table [dataSource]="coinsuranceData"  [trackBy]="trackById" class="full-width-table">
                          <!-- Procedure Column -->
                          <ng-container matColumnDef="coinsurance">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'coinsurance')"> CoInsurance </th>
                            <td mat-cell *matCellDef="let coinsurance; let i = index" class="coinsurance-name">
                              {{ coinsurance.serviceName }}
                              <span *ngIf="isAuditFailed(coinsurance)" class="audit-fail-marker"
                                    [matTooltip]="auditFailureTooltip(coinsurance)" matTooltipPosition="above"
                                    matTooltipClass="audit-failure-tooltip" aria-label="Audit correction required">
                                <i class="fa-solid fa-circle-exclamation"></i> Review
                              </span>
                            </td>
                          </ng-container>

                          <!-- Coverage Level Column -->
                          <!--                          <ng-container matColumnDef="coverageLevel">-->
                          <!--                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'coverageLevel')"> Coverage </th>-->
                          <!--                            <td mat-cell *matCellDef="let coverageLevel; let i = index" [ngClass]="{ 'highlight-empty': isCoFormInitialized && !coinsurances.at(i).get('coverageLevel')?.value }">-->
                          <!--                                <mat-form-field class="full-width-input spaced-field small-placeholder">-->
                          <!--                                    <input matInput [formControl]="coinsurances.at(i).get('coverageLevel')" [disabled]="!isEditable">-->
                          <!--                                    <mat-placeholder>coverage Level</mat-placeholder>-->
                          <!--                                </mat-form-field>-->
                          <!--                            </td>-->
                          <!--                          </ng-container>-->

                          <!-- Percent Column -->
                          <ng-container matColumnDef="percent">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'percent')"> Percent </th>
                            <td mat-cell *matCellDef="let percent; let i = index" [ngClass]="{ 'highlight-empty': isCoFormInitialized && !coinsurances.at(i).get('percent')?.value }">
                              <mat-form-field class="full-width-input spaced-field small-placeholder">
                                <input matInput data-control="percent" [formControl]="coinsurances.at(i).get('percent')" [disabled]="!isEditable">
                                <mat-placeholder>percent</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Waiting Period Column -->
                          <ng-container matColumnDef="waitingPeriod">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'waitingPeriod')"> Waiting Period </th>
                            <td mat-cell *matCellDef="let waitingPeriod; let i = index">
                              <mat-form-field class="full-width-input spaced-field small-placeholder">
                                <input data-control="waitingPeriod" matInput [formControl]="coinsurances.at(i).get('waitingPeriod')" [disabled]="!isEditable || !waitingPeriodEnabled">
                                <mat-placeholder>waiting Period</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="deductible">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'deductible')"> Deductible applies </th>
                            <td mat-cell *matCellDef="let deductible; let i = index">
                              <mat-form-field class="full-width-input spaced-field small-placeholder">
                                <input matInput data-control="deductible" [formControl]="coinsurances.at(i).get('deductible')" [disabled]="!isEditable">
                                <mat-placeholder>Deductible</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Message Column -->
                          <!--                          <ng-container matColumnDef="message">-->
                          <!--                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'message')"> Message</th>-->
                          <!--                            <td mat-cell *matCellDef="let percent; let i = index" [ngClass]="{ 'highlight-empty': isCoFormInitialized && !coinsurances.at(i).get('message')?.value }">-->
                          <!--                                <mat-form-field class="full-width-input spaced-field small-placeholder">-->
                          <!--                                      <textarea matInput-->
                          <!--                                                [formControl]="coinsurances.at(i).get('message')"-->
                          <!--                                                rows="3"-->
                          <!--                                                cdkTextareaAutosize-->
                          <!--                                                cdkAutosizeMinRows="3"-->
                          <!--                                                cdkAutosizeMaxRows="5"-->
                          <!--                                                (focus)="onFocus(i)"-->
                          <!--                                                (blur)="onBlur(i)"-->
                          <!--                                                [disabled]="!isEditable">-->
                          <!--                                      </textarea>-->
                          <!--                                    <mat-label *ngIf="!isFocused[i] && !coinsurances.at(i).get('message')?.value">Enter Message</mat-label>-->
                          <!--                                </mat-form-field>-->
                          <!--                            </td>-->
                          <!--                          </ng-container>-->

                          <!-- Table Headers and Rows -->
                          <tr mat-header-row *matHeaderRowDef="coinsuranceColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: coinsuranceColumns; let i = index"
                             [class.audit-failed-question-row]="isAuditFailed(row)"
                             [matTooltip]="auditFailureTooltip(row)"
                             [matTooltipDisabled]="!isAuditFailed(row)"
                             matTooltipPosition="above"
                             matTooltipClass="audit-failure-tooltip"
                             (keydown)="onCoInsuranceRowKeydown($event, i)">
                          </tr>
                        </table>
                      </fieldset>
                      <!-- Buttons for submit and cancel -->
                      <div class="form-buttons mt-2">
                        <button type="button" routerLink="/userworkarea" *ngIf="!isVertical && !isHidden" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                        <button *ngIf="!coinsuranceExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceCoveragesForm.valid || !isEditable || isFormDisabled || viewMode === 'patient'|| !verificationFormEditable">
                          Add Co Insurance
                        </button>
                        <button *ngIf="coinsuranceExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceCoveragesForm.valid || !isEditable || isFormDisabled || viewMode === 'patient'|| !verificationFormEditable">
                          Update Co Insurance
                        </button>
                        <!-- Toggle Button -->
                        <div class="toggle-switch">
                          <label class="switch">
                            <input type="checkbox" (change)="checkCoInsAllFieldsStatus()" [checked]="allCoFieldsFilled" [disabled]="true">
                            <span class="slider"></span>
                          </label>
                          <span class="toggle-status-text">
                                {{ allCoFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                        </div>
                      </div>
                    </form>
                  </ng-template>

                  <ng-template #tplCoverageFreq>
                    <form [formGroup]="insuranceCoveragesForm" class="full-width-form">
                      <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                        <table mat-table [dataSource]="coveragesData"  [trackBy]="trackById" class="full-width-table">
                          <!-- Procedure Column -->
                          <ng-container matColumnDef="procedure">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'procedure')"> Procedure </th>
                            <td mat-cell *matCellDef="let procedure; let i = index" class="procedure-name">
                              {{ procedure.serviceName }}
                              <span *ngIf="isAuditFailed(procedure)" class="audit-fail-marker"
                                    [matTooltip]="auditFailureTooltip(procedure)" matTooltipPosition="above"
                                    matTooltipClass="audit-failure-tooltip" aria-label="Audit correction required">
                                <i class="fa-solid fa-circle-exclamation"></i> Review
                              </span>
                            </td>
                          </ng-container>

                          <!-- Percent Column -->
                          <ng-container matColumnDef="percentage">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'percentage')"> Percent </th>
                            <td mat-cell *matCellDef="let procedure; let i = index" [ngClass]="{ 'highlight-empty': isCoverageFormInitialized && !procedures.at(i).get('percentage')?.value }">
                              <mat-form-field class="full-width-input spaced-field small-placeholder">
                                <input
                                  matInput
                                  data-control="percentage"
                                  [formControl]="procedures.at(i).get('percentage')">
                                <mat-placeholder>Enter Percent</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Frequency Column -->
                          <ng-container matColumnDef="frequency">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'frequency')"> Frequency </th>
                            <td mat-cell *matCellDef="let procedure; let i = index" [ngClass]="{ 'highlight-empty': isCoverageFormInitialized && !procedures.at(i).get('frequency')?.value }">
                            <mat-form-field class="full-width-input spaced-field small-placeholder frequency-wrap-field">
                              <textarea
                                matInput
                                data-control="frequency"
                                [formControl]="procedures.at(i).get('frequency')"
                                placeholder="Enter Frequency"
                                rows="1"
                                cdkTextareaAutosize
                                cdkAutosizeMinRows="1">
                              </textarea>
                            </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Guidelines Column -->
                          <ng-container matColumnDef="guidelines">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'guidelines')"> Guidelines </th>
                            <td mat-cell *matCellDef="let procedure; let i = index">
                              <mat-form-field class="full-width-input spaced-field-message small-placeholder">
              <textarea
                matInput
                data-control="guidelines"
                [formControl]="procedures.at(i).get('guidelines')"
                rows="3"
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="5"
                (focus)="onFocus(i)"
                (blur)="onBlur(i)"></textarea>
                                <mat-label *ngIf="!isFocused[i] && !procedures.at(i).get('guidelines')?.value">Enter Guidelines</mat-label>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Age Column -->
                          <ng-container matColumnDef="agelimit">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'agelimit')">
                              Age Limit
                            </th>
                            <td mat-cell *matCellDef="let procedure; let i = index">
                              <div class="age-limit-container">
                                <mat-form-field class="full-width-input spaced-field small-placeholder">
                                  <input
                                    matInput
                                    data-control="agelowvalue"
                                    [formControl]="procedures.at(i).get('agelowvalue')"
                                    placeholder="Age">
                                </mat-form-field>
                              </div>
                            </td>
                          </ng-container>

                          <!-- Table Headers and Rows -->
                          <tr mat-header-row *matHeaderRowDef="coverageColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: coverageColumns; let i = index"
                             [class.audit-failed-question-row]="isAuditFailed(row)"
                             [matTooltip]="auditFailureTooltip(row)"
                             [matTooltipDisabled]="!isAuditFailed(row)"
                             matTooltipPosition="above"
                             matTooltipClass="audit-failure-tooltip"
                             (keydown)="onCoverageRowKeydown($event, i)">
                          </tr>
                        </table>
                      </fieldset>

                      <div class="form-buttons mt-2">
                        <button type="button" routerLink="/userworkarea" *ngIf="!isVertical && !isHidden" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                        <button *ngIf="!coverageExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceCoveragesForm.valid || !isEditable || isFormDisabled || viewMode === 'patient' || !verificationFormEditable">
                          Add Coverages
                        </button>
                        <button *ngIf="coverageExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!insuranceCoveragesForm.valid || !isEditable || isFormDisabled || viewMode === 'patient' || !verificationFormEditable">
                          Update Coverages
                        </button>

                        <div class="toggle-switch">
                          <label class="switch">
                            <input type="checkbox" (change)="checkCoverageInsAllFieldsStatus()" [checked]="allCoverageFieldsFilled" [disabled]="true">
                            <span class="slider"></span>
                          </label>
                          <span class="toggle-status-text">
          {{ allCoverageFieldsFilled ? 'Verified' : 'Pending Verification' }}
        </span>
                        </div>
                      </div>
                    </form>
                  </ng-template>

                  <ng-template #tplOrtho>
                    <form [formGroup]="orthoForm" class="full-width-form">
                      <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                        <table mat-table [dataSource]="orthoData"  [trackBy]="trackById" class="full-width-table">
                          <!-- Ortho Column -->
                          <ng-container matColumnDef="ortho">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'ortho')"> Ortho Procedure </th>
                            <td mat-cell *matCellDef="let ortho; let i = index" class="procedure-name">
                              {{ ortho.serviceName }}
                              <span *ngIf="isAuditFailed(ortho)" class="audit-fail-marker"
                                    [matTooltip]="auditFailureTooltip(ortho)" matTooltipPosition="above"
                                    matTooltipClass="audit-failure-tooltip" aria-label="Audit correction required">
                                <i class="fa-solid fa-circle-exclamation"></i> Review
                              </span>
                              <!--                                          <mat-form-field class="full-width-input spaced-field small-placeholder">-->
                              <!--                                              <input matInput [formControl]="orthos.at(i).get('ortho')" placeholder="Enter Procedure"/>-->
                              <!--                                          </mat-form-field>-->
                            </td>
                          </ng-container>

                          <!-- Ortho Coverage Column -->
                          <!--                                  <ng-container matColumnDef="orthoCoverage">-->
                          <!--                                      <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'orthoCoverage')"> Ortho Coverage </th>-->
                          <!--                                      <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoCoverage')?.value }">-->
                          <!--                                          <mat-form-field class="full-width-input spaced-field small-placeholder">-->
                          <!--                                              <input matInput [formControl]="orthos.at(i).get('orthoCoverage')" [attr.disabled]="!isEditable">-->
                          <!--                                              <mat-placeholder>Enter Coverage</mat-placeholder>-->
                          <!--                                          </mat-form-field>-->
                          <!--                                      </td>-->
                          <!--                                  </ng-container>-->

                          <!-- Ortho Percentage Column -->
                          <ng-container matColumnDef="orthoPercent">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'orthoPercent')"> Ortho Percent </th>
                            <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoPercent')?.value }">
                              <mat-form-field class="full-width-input spaced-field small-placeholder">
                                <input
                                  matInput
                                  data-control="orthoPercent"
                                  [formControl]="orthos.at(i).get('orthoPercent')"
                                  [attr.disabled]="!isEditable ? true : null"
                                  placeholder="Enter Percentage">
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Ortho Frequency Column -->
                          <ng-container matColumnDef="orthoFrequency">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'orthoFrequency')"> Ortho Frequency </th>
                            <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoFrequency')?.value }">
                              <mat-form-field class="full-width-input spaced-field small-placeholder frequency-wrap-field">
                                <textarea
                                  matInput
                                  data-control="orthoFrequency"
                                  [formControl]="orthos.at(i).get('orthoFrequency')"
                                  [attr.disabled]="!isEditable ? true : null"
                                  placeholder="Enter Frequency"
                                  rows="1"
                                  cdkTextareaAutosize
                                  cdkAutosizeMinRows="1">
                                </textarea>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Ortho History Column -->
                          <!--                                  <ng-container matColumnDef="orthoHistory">-->
                          <!--                                      <th mat-header-cell *matHeaderCellDef class="resizable-column coverage-header" (mousedown)="startResize($event, 'orthoHistory')"> Ortho History </th>-->
                          <!--                                      <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoHistory')?.value }">-->
                          <!--                                          <mat-form-field class="full-width-input spaced-field small-placeholder">-->
                          <!--                                              <input matInput [formControl]="orthos.at(i).get('orthoHistory')" [attr.disabled]="!isEditable">-->
                          <!--                                              <mat-placeholder>Enter History</mat-placeholder>-->
                          <!--                                          </mat-form-field>-->
                          <!--                                      </td>-->
                          <!--                                  </ng-container>-->

                          <!-- Guidelines Column -->
                          <ng-container matColumnDef="orthoGuidelines">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'orthoGuidelines')"> Guidelines </th>
                            <td mat-cell *matCellDef="let ortho; let i = index" [ngClass]="{ 'highlight-empty': isOrthoFormInitialized && !orthos.at(i).get('orthoGuidelines')?.value }">
                              <mat-form-field class="full-width-input spaced-field-message small-placeholder">
                    <textarea matInput
                              data-control="orthoGuidelines"
                              [formControl]="orthos.at(i).get('orthoGuidelines')"
                              rows="3"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="3"
                              cdkAutosizeMaxRows="5"
                              (focus)="onFocus(i)"
                              (blur)="onBlur(i)"
                              [attr.disabled]="!isEditable"></textarea>
                                <mat-label *ngIf="!isFocused[i] && !orthos.at(i).get('orthoGuidelines')?.value">Enter Guidelines</mat-label>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="age">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column" (mousedown)="startResize($event, 'age')"> Age Limit </th>
                            <td mat-cell *matCellDef="let ortho; let i = index">
                              <mat-form-field class="full-width-input spaced-field small-placeholder">
                                <input matInput data-control="age" [formControl]="orthos.at(i).get('age')" [attr.disabled]="!isEditable">
                                <mat-placeholder>Enter Frequency</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Table Headers and Rows -->
                          <tr mat-header-row *matHeaderRowDef="orthoColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: orthoColumns; let i = index"
                             [class.audit-failed-question-row]="isAuditFailed(row)"
                             [matTooltip]="auditFailureTooltip(row)"
                             [matTooltipDisabled]="!isAuditFailed(row)"
                             matTooltipPosition="above"
                             matTooltipClass="audit-failure-tooltip"
                             (keydown)="onOrthoRowKeydown($event, i)">
                          </tr>
                        </table>
                      </fieldset>
                      <!-- Buttons and toggle remain enabled -->
                      <div class="form-buttons mt-2">
                        <button type="button" routerLink="/userworkarea" *ngIf="!isVertical && !isHidden" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                        <button *ngIf="!orthoExists && !isVertical && !isHidden"
                                class="btn btn-outline-light btn-sm px-5 float-right"
                                mat-raised-button
                                color="primary"
                                type="submit"
                                [disabled]="!orthoForm.valid || !isEditable || isFormDisabled || viewMode === 'patient' || !verificationFormEditable">
                          Add Ortho
                        </button>
                        <button *ngIf="orthoExists && !isVertical && !isHidden"
                                class="btn btn-outline-light btn-sm px-5 float-right"
                                mat-raised-button
                                color="primary"
                                type="submit"
                                [disabled]="!orthoForm.valid || !isEditable || isFormDisabled || viewMode === 'patient' || !verificationFormEditable">
                          Update Ortho
                        </button>
                        <div class="toggle-switch">
                          <label class="switch">
                            <input type="checkbox"
                                   (change)="checkOrthoAllFieldsStatus()"
                                   [checked]="allOrthoFieldsFilled" [disabled]="true">
                            <span class="slider"></span>
                          </label>
                          <span class="toggle-status-text">
                {{ allOrthoFieldsFilled ? 'Verified' : 'Pending Verification' }}
            </span>
                        </div>
                      </div>
                    </form>
                  </ng-template>

                  <ng-template #tplHistory>
                    <form [formGroup]="historyForm" (ngSubmit)="onSubmitHistory()" class="full-width-form">
                      <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                        <table mat-table [dataSource]="historyData"  [trackBy]="trackById" class="full-width-table">
                          <!-- History question Column -->
                          <ng-container matColumnDef="historyName">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column procedure-header" (mousedown)="startResize($event, 'historyName')"> History Name </th>
                            <td mat-cell *matCellDef="let historyName; let i = index" class="procedure-name">
                              {{ historyName.serviceName }}
                              <span *ngIf="isAuditFailed(historyName)" class="audit-fail-marker"
                                    [matTooltip]="auditFailureTooltip(historyName)" matTooltipPosition="above"
                                    matTooltipClass="audit-failure-tooltip" aria-label="Audit correction required">
                                <i class="fa-solid fa-circle-exclamation"></i> Review
                              </span>
                              <!--                                <mat-form-field class="full-width-input spaced-field small-placeholder">-->
                              <!--                                    <input matInput [formControl]="historiesInput.at(i).get('historyName')" />-->
                              <!--                                </mat-form-field>-->
                            </td>
                          </ng-container>

                          <!-- History Input Column -->
                          <ng-container matColumnDef="historyInput">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'historyInput')"> History Input </th>
                            <td mat-cell *matCellDef="let historyInput; let i = index" [ngClass]="{ 'highlight-empty': isHistoryFormInitialized && !historiesInput.at(i).get('historyInput')?.value }">
                              <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                <input matInput data-control="historyInput" [formControl]="historiesInput.at(i).get('historyInput')">
                                <mat-placeholder class="text-center">Enter Histories</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!--History Eligibility-->
                          <ng-container matColumnDef="historyEligibility">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'historyInput')"> Eligibility </th>
                            <td mat-cell *matCellDef="let historyEligibility; let i = index">
                              <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                <input matInput data-control="historyEligibility" [formControl]="historiesInput.at(i).get('historyEligibility')">
                                <mat-placeholder class="text-center">Enter Eligibility</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Table Headers and Rows -->
                          <tr mat-header-row *matHeaderRowDef="historyColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: historyColumns; let i = index"
                             [class.audit-failed-question-row]="isAuditFailed(row)"
                             [matTooltip]="auditFailureTooltip(row)"
                             [matTooltipDisabled]="!isAuditFailed(row)"
                             matTooltipPosition="above"
                             matTooltipClass="audit-failure-tooltip"
                             (keydown)="onHistoryRowKeydown($event, i)">
                          </tr>
                        </table>
                      </fieldset>

                      <!-- Buttons for submit and cancel -->
                      <div class="form-buttons mt-2">
                        <button type="button" routerLink="/userworkarea" *ngIf="!isVertical && !isHidden" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                        <button *ngIf="!historyExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!historyForm.valid || !isEditable || viewMode === 'patient' || !verificationFormEditable">
                          Submit History Info
                        </button>
                        <button *ngIf="historyExists && !isVertical && !isHidden" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!historyForm.valid || !isEditable || viewMode === 'patient' || !verificationFormEditable">
                          Update
                        </button>
                        <!-- Toggle Button -->
                        <div class="toggle-switch">
                          <label class="switch">
                            <input type="checkbox" (change)="checkHistAllFieldsStatus()" [checked]="allHistFieldsFilled" [disabled]="true">
                            <span class="slider"></span>
                          </label>
                          <span class="toggle-status-text">
                                {{ allHistFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                        </div>
                      </div>
                    </form>
                  </ng-template>

                  <ng-template #tplShortForm>
                    <form [formGroup]="historyForm" (ngSubmit)="onSubmitHistory()" class="full-width-form">
                      <fieldset [disabled]="viewMode === 'patient' || !verificationFormEditable">
                        <table mat-table [dataSource]="historyData"  [trackBy]="trackById" class="full-width-table">
                          <!-- Procedure Name Column -->
                          <ng-container matColumnDef="historyName">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column procedure-header" (mousedown)="startResize($event, 'historyName')"> History Name </th>
                            <td mat-cell *matCellDef="let historyName; let i = index" class="procedure-name">
                              {{ historyName.serviceName }}
                              <span *ngIf="isAuditFailed(historyName)" class="audit-fail-marker"
                                    [matTooltip]="auditFailureTooltip(historyName)" matTooltipPosition="above"
                                    matTooltipClass="audit-failure-tooltip" aria-label="Audit correction required">
                                <i class="fa-solid fa-circle-exclamation"></i> Review
                              </span>
                              <!--                                <mat-form-field class="full-width-input spaced-field small-placeholder">-->
                              <!--                                    <input matInput [formControl]="historiesInput.at(i).get('historyName')" />-->
                              <!--                                </mat-form-field>-->
                            </td>
                          </ng-container>

                          <!-- Procedure Input Column -->
                          <ng-container matColumnDef="historyInput">
                            <th mat-header-cell *matHeaderCellDef class="resizable-column pl-2" (mousedown)="startResize($event, 'historyInput')"> History Input </th>
                            <td mat-cell *matCellDef="let historyInput; let i = index" [ngClass]="{ 'highlight-empty': isHistoryFormInitialized && !historiesInput.at(i).get('historyInput')?.value }">
                              <mat-form-field  class="full-width-input spaced-field small-placeholder">
                                <input matInput [formControl]="historiesInput.at(i).get('historyInput')">
                                <mat-placeholder class="text-center">Enter Histories</mat-placeholder>
                              </mat-form-field>
                            </td>
                          </ng-container>

                          <!-- Table Headers and Rows -->
                          <tr mat-header-row *matHeaderRowDef="historyColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: historyColumns;"></tr>
                        </table>
                      </fieldset>
                      <!-- Buttons for submit and cancel -->
                      <div class="form-buttons mt-2">
                        <button type="button" routerLink="/userworkarea" class="btn btn-secondary float-end waves-effect waves-light">Cancel</button>
                        <button *ngIf="!historyExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!historyForm.valid || !isEditable || viewMode === 'patient' || !verificationFormEditable">
                          Submit History Info
                        </button>
                        <button *ngIf="historyExists" class="btn btn-outline-light btn-sm px-5 float-right" mat-raised-button color="primary" type="submit" [disabled]="!historyForm.valid || !isEditable || viewMode === 'patient' || !verificationFormEditable">
                          Update
                        </button>
                        <!-- Toggle Button -->
                        <div class="toggle-switch">
                          <label class="switch">
                            <input type="checkbox" (change)="checkHistAllFieldsStatus()" [checked]="allHistFieldsFilled" [disabled]="true">
                            <span class="slider"></span>
                          </label>
                          <span class="toggle-status-text">
                                {{ allHistFieldsFilled ? 'Verified' : 'Pending Verification' }}
                              </span>
                        </div>
                      </div>
                    </form>
                  </ng-template>

                  <!-- Add similar templates: tplCoInsurance, tplCoverageFreq, tplOrtho, tplHistory, tplShortForm -->
                  <!-- Use your existing content from the tabs, unchanged, inside each template. -->

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


